import { SVGFC } from '@repo/toolkit/types'

const CheckMarkIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 13.2L8.57143 18L20 6"
        stroke={color}
        strokeWidth="2.28571"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CheckMarkIcon
